export default () => {
  const links = document.querySelectorAll(".js-utility-nav-popup-link");

  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      // The popup is assumed to be the next sibling element
      const popup = link.nextElementSibling;

      /// Close all other popups before toggling the current one
      document.querySelectorAll(".utility-nav__popup").forEach((el) => {
        if (el !== popup) el.classList.remove("is-visible");
      });

      // Toggle the visibility of the clicked popup
      popup.classList.toggle("is-visible");
    });
  });

  // Close any open popup when clicking outside of it
  document.addEventListener("click", (e) => {
    const isClickInside =
      e.target.closest(".utility-nav__popup") ||
      e.target.closest(".js-utility-nav-popup-link");
    if (!isClickInside) {
      document.querySelectorAll(".utility-nav__popup").forEach((el) => {
        el.classList.remove("is-visible");
      });
    }
  });
};
